// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__FG5AL","buttons":"SendReceipts_buttons__1jvBd","email":"SendReceipts_email__3pSDD","bookApptTitle":"SendReceipts_bookApptTitle__3myBB"};